import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {PaymentMode} from './model';

export interface PaymentModeState extends EntityState<PaymentMode> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'PaymentMode' })
export class Store extends EntityStore<PaymentModeState> {

  constructor() {
    super();
  }

}
